// extracted by mini-css-extract-plugin
export default {"meals":"Skills_meals__8Uc23","meals-appear":"Skills_meals-appear__H-pQJ"};